import { isNumeric } from './isNumeric';
import { number_format } from './number_format';
import { CURRENCY } from '@/constants/Currency';

const DEFAULT_CURRENCY_OBJ = { name:'Euro', isocode:'EUR', symbol:'€', symbolPosition: 'right', thousendSign: '.', decimalSign: ',' };

export function formatPrice(price, currency = null) {
    
    if (price == null || isNumeric(price) === false) {
        return '';
    }
    
    const isIso = currency?.iso != null;

    const currencyObj = isIso ? CURRENCY.find(item => item.isocode == currency?.iso) ?? DEFAULT_CURRENCY_OBJ : DEFAULT_CURRENCY_OBJ;
    
    const {
        symbol: currencySymbol = '€',
        thousendSign: currencyThousendSign = '.',
        decimalSign: currencyDecimalSign = ',',
        symbolPosition: currencySymbolPosition = 'right'
    } = (isIso ? currencyObj : currency);

    if (currencySymbolPosition === 'right') {
        return `${number_format(price, 2, currencyDecimalSign, currencyThousendSign)}\u2009${currencySymbol}`;
    }

    return `${currencySymbol}\u2009${number_format(price, 2, currencyDecimalSign, currencyThousendSign)}`;
    
}